import request from '@/utils/request'

export function findEsimInventories(params) {
  return request({
    url: `/esim_inventories`,
    method: 'get',
    params
  })
}

export function findEsimInventoryImportRecords(params) {
  return request({
    url: `/esim_inventories/import_records`,
    method: 'get',
    params
  })
}

export function importEsimInventories(data) {
  return request({
    url: `/esim_inventories/import`,
    method: 'post',
    data
  })
}

export function reImportEsimInventories(data) {
  return request({
    url: `/esim_inventories/re_import`,
    method: 'post',
    data
  })
}

export function exportEsimInventories(data) {
  return request({
    url: `/esim_inventories/export`,
    method: 'post',
    data
  })
}

export function destroyEsimInventories(data) {
  return request({
    url: `/batch_operations/esim_inventories`,
    method: 'delete',
    data
  })
}
